/* One floating action, using the card's existing product link or native add form.
   Mirrored into the native theme patch; parity is checked by storefront tests. */
(() => {
  if (document.querySelector('[data-acqua-card-hover-style]')) return;
  const style = document.createElement('style');
  style.setAttribute('data-acqua-card-hover-style', '');
  style.textContent = `
    .acqua-product-hub__card.acqua-card-footer-open,
    .acqua-card-b .productitem.acqua-card-footer-open {
      border-color: #8eafb9; border-bottom-color: transparent;
      border-bottom-left-radius: 0; border-bottom-right-radius: 0;
      box-shadow: 0 4px 12px #06486212;
    }
    .acqua-card-hover-panel {
      background: #fff; border: 1px solid #8eafb9; border-top: 0;
      border-radius: 0 0 12px 12px; box-shadow: 0 7px 14px #06486220;
      box-sizing: border-box; padding: 9px; position: fixed; z-index: 100;
    }
    .acqua-card-hover-panel[hidden] { display: none; }
    .acqua-card-hover-panel a, .acqua-card-hover-panel button {
      background: #eaf3f6; border-radius: 7px; box-sizing: border-box;
      color: #205f78; display: block; font: inherit; font-size: .8rem;
      font-weight: 700; line-height: 1.3; min-height: 40px; padding: 11px 5px;
      text-align: center; text-decoration: none; border: 0; width: 100%; cursor: pointer;
    }
    .acqua-card-hover-panel a:focus-visible, .acqua-card-hover-panel button:focus-visible { outline: 2px solid #205f78; outline-offset: 2px; }
    .acqua-card-hover-panel a:hover, .acqua-card-hover-panel button:hover { background: #dcecf2; }
    .acqua-card-hover-panel form { margin: 0; }
    .acqua-card-touch-action { display: none; }
    @media (hover: none), (pointer: coarse) {
      .acqua-card-hover-panel { display: none; }
      .acqua-product-hub__card .acqua-product-hub__card-action {
        display: block; color: #205f78; font-size: .75rem; font-weight: 700; margin-top: 8px;
      }
      .acqua-card-b .acqua-card-touch-action {
        display: block; color: #205f78; font-size: .75rem; font-weight: 700;
        margin-top: 8px; text-decoration: none;
      }
    }
    .acqua-card-touch-action button {
      border: 0; border-radius: 7px; background: #eaf3f6; color: #205f78;
      font: inherit; font-weight: 700; width: 100%; min-height: 40px; cursor: pointer;
    }
    @media (prefers-reduced-motion: reduce) { .acqua-card-footer-open { transition: none; } }
  `;
  document.head.appendChild(style);
  const syncTouchActions = () => {
    document.querySelectorAll('.acqua-card-b .productitem').forEach((card) => {
      if (card.closest('.asv6-featured-product')) return;
      if (card.querySelector('.acqua-card-touch-action')) return;
      const source = card.querySelector('.acqua-card-action');
      const info = card.querySelector('.productitem--info');
      if (source?.tagName === 'FORM' && info) {
        const fallback = source.cloneNode(true);
        fallback.className = 'acqua-card-touch-action';
        info.appendChild(fallback);
        return;
      }
      const href = source?.getAttribute('href');
      if (!info || !href || new URL(href, location.href).origin !== location.origin) return;
      const fallback = document.createElement('a');
      fallback.className = 'acqua-card-touch-action';
      fallback.href = href;
      fallback.textContent = source.textContent.trim();
      fallback.setAttribute('aria-label', source.getAttribute('aria-label') || fallback.textContent);
      info.appendChild(fallback);
    });
  };
  syncTouchActions();

  const panel = document.createElement('div');
  panel.className = 'acqua-card-hover-panel';
  panel.hidden = true;
  const link = document.createElement('a');
  let activeControl = link;
  // The original card link is the keyboard entry point; do not duplicate tab stops.
  link.tabIndex = -1;
  panel.appendChild(link);
  const cardSelector = '.acqua-product-hub__card, .acqua-card-b .productitem';
  let owner = null;
  let closeTimer;
  let frame = null;
  let pointer = null;
  const hide = () => {
    clearTimeout(closeTimer);
    owner?.classList.remove('acqua-card-footer-open');
    panel.hidden = true;
    owner = null;
  };
  const show = (card) => {
    if (card.closest('.asv6-featured-product')) return hide();
    const action = card.querySelector('.acqua-product-hub__card-action, .acqua-card-action');
    const source = card.querySelector('.acqua-product-hub__card-link, .acqua-card-action');
    if (!action || !source || !card.isConnected || card.closest('.is-dragging')) return hide();
    const nativeForm = action.tagName === 'FORM';
    const href = source.getAttribute(nativeForm ? 'action' : 'href');
    if (!href || new URL(href, location.href).origin !== location.origin) return hide();
    const rect = card.getBoundingClientRect();
    const rail = card.closest('.acqua-product-rail, .flickity-viewport');
    const clip = rail?.getBoundingClientRect();
    if (rect.width <= 0 || rect.bottom <= 0 || rect.top >= window.innerHeight
      || rect.left < Math.max(0, clip?.left || 0) - 2
      || rect.right > Math.min(window.innerWidth, clip?.right || window.innerWidth) + 2) return hide();
    clearTimeout(closeTimer);
    if (owner !== card) owner?.classList.remove('acqua-card-footer-open');
    const changedOwner = owner !== card;
    owner = card;
    owner.classList.add('acqua-card-footer-open');
    if (nativeForm) {
      if (changedOwner || activeControl === link) {
        const form = action.cloneNode(true);
        form.className = 'acqua-card-hover-add';
        activeControl = form.querySelector('button');
        activeControl.tabIndex = -1;
        panel.replaceChildren(form);
      }
    } else {
      if (activeControl !== link) panel.replaceChildren(link);
      activeControl = link;
    }
    link.href = href;
    if (link.textContent !== action.textContent.trim()) link.textContent = action.textContent.trim();
    link.setAttribute('aria-label', source.getAttribute('aria-label') || link.textContent);
    // Modal descendants must stay inside their dialog's non-inert subtree.
    const host = card.closest('dialog[open]') || document.body;
    if (panel.parentElement !== host) host.appendChild(panel);
    panel.style.left = `${Math.max(0, Math.min(rect.left, window.innerWidth - rect.width))}px`;
    panel.style.top = `${rect.bottom - 1}px`;
    panel.style.width = `${rect.width}px`;
    panel.hidden = false;
  };
  const withinActive = (node) => node instanceof Element && (owner?.contains(node) || panel.contains(node));
  const delayedHide = () => { clearTimeout(closeTimer); closeTimer = setTimeout(hide, 140); };
  const refresh = () => {
    frame = null;
    if (!owner) return;
    if (!owner.isConnected) return hide();
    if (withinActive(document.activeElement)) return show(owner);
    if (pointer) {
      const hit = document.elementFromPoint(pointer.x, pointer.y);
      if (panel.contains(hit)) return show(owner);
      const card = hit?.closest(cardSelector);
      if (card) return show(card);
    }
    hide();
  };
  const schedule = () => { if (!frame && owner) frame = requestAnimationFrame(refresh); };
  document.addEventListener('pointerover', (event) => {
    if (event.pointerType !== 'mouse' || !window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;
    pointer = { x: event.clientX, y: event.clientY };
    if (panel.contains(event.target)) { clearTimeout(closeTimer); return; }
    const card = event.target instanceof Element ? event.target.closest(cardSelector) : null;
    if (card) show(card);
  });
  document.addEventListener('pointermove', (event) => {
    if (event.pointerType !== 'mouse') return;
    pointer = { x: event.clientX, y: event.clientY };
    if (owner?.closest('.is-dragging')) hide();
  }, { passive: true });
  document.addEventListener('pointerout', (event) => {
    if (withinActive(event.target) && !withinActive(event.relatedTarget)) delayedHide();
  });
  document.addEventListener('focusin', (event) => {
    if (panel.contains(event.target)) { clearTimeout(closeTimer); return; }
    const card = event.target instanceof Element ? event.target.closest(cardSelector) : null;
    if (card) show(card);
  });
  document.addEventListener('focusout', (event) => {
    if (withinActive(event.target) && !withinActive(event.relatedTarget)) delayedHide();
  });
  document.addEventListener('pointerdown', (event) => { if (!withinActive(event.target)) hide(); });
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') hide();
    if (event.key !== 'Tab' || panel.hidden) return;
    // Make the visible footer reachable directly from its card, not page-end.
    const cardEntries = Array.from(owner.querySelectorAll('a[href], button, input, select, textarea, [tabindex="0"]'))
      .filter((entry) => !entry.disabled && entry.getClientRects().length);
    if (!event.shiftKey && event.target === cardEntries.at(-1)) {
      event.preventDefault(); activeControl.focus();
    } else if (panel.contains(event.target)) {
      const entries = Array.from(document.querySelectorAll('a[href], button, input, select, textarea, [tabindex="0"]'))
        .filter((entry) => !entry.disabled && entry.getClientRects().length && !panel.contains(entry));
      const last = entries.findLastIndex((entry) => owner.contains(entry));
      const next = entries[event.shiftKey ? last : last + 1];
      if (next) { event.preventDefault(); next.focus(); }
      if (!event.shiftKey) hide();
    }
  });
  document.addEventListener('scroll', schedule, true);
  document.addEventListener('close', hide, true);
  document.addEventListener('toggle', schedule, true);
  window.addEventListener('resize', schedule);
  window.addEventListener('blur', hide);
  new MutationObserver((records) => {
    if (!records.some((record) => record.target !== panel)) return;
    syncTouchActions(); schedule();
  }).observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['hidden', 'open'] });
})();
